import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import AddCircleIcon from "@mui/icons-material/AddCircle"
import EditIcon from "@mui/icons-material/Edit"
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined"
import { Autocomplete, Box, Container, Grid, TextField, Typography } from "@mui/material"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
import { hasRole } from "auth/hasRole"
import { useApiFile } from "auth/useApi2"
import { useApi } from "auth/useApi3"
import { AppContext } from "components/AppContextProvider"
import ClpButton from "components/Button"
import ContinueDialog from "components/Dialogs/ContinueDialog"
import SuccessDialog from "components/Dialogs/SuccessDialog"
import { GlobalLoaderContext } from "components/GlobalLoadingProvider"
import MultipleFilePickerPreviewList from "components/MultipleFilePickerPreviewList"
import { RouterPrompt } from "components/RouterPrompt"
import theme from "css/theme/light"
import { Formik } from "formik"
import { apiEndpoints } from "generated/apiEndpoints"
import { allRoles } from "generated/roles"
import { allRoutes } from "generated/routes"
import { issueReportStatusColor } from "helpers/IssueReports/IssueReportStatusColor"
import { issueReportStatusIcon } from "helpers/IssueReports/IssueReportStatusIcon"
import { issueReportStatusLabel } from "helpers/IssueReports/IssueReportStatusLabel"
import moment from "moment"
import React, { useContext, useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import Moment from "react-moment"
import { Link, useHistory } from "react-router-dom"
import { StyledListItem, StyledWhiteBox } from "shared/styled/General"
import * as Yup from "yup"
import WorkOrderTitle from "../../../workorders/components/WorkOrderTitle"
import {
  StyledInlineBox,
  StyledInlineBoxLabel,
  StyledTwoButtonGrid,
  StyledWrapCard
} from "./IssueReports.styled"

const IssueReports = ({ issuereportResult }) => {
  // formik initialvalues
  const initialValues = {
    issueReportCategoryId: "",
    description: "",
    attachments: []
  }

  const appContext = useContext(AppContext)
  const loadingContext = React.useContext(GlobalLoaderContext)
  const [userstoassign, userstoassignFuncs] = useApi([])
  const [showDeleteModel, setShowDeleteModal] = useState(false)
  const [showContinueModal, setShowContinueModal] = useState(false)
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [editMode, setEditMode] = useState(false)
  const [parentData, setParentData] = useState(issuereportResult.data)
  const [chosenCategory, setChosenCategory] = useState("")
  const [updatedIssuereportResult, issuereportFuncs] = useApi()
  const [deleteResult, deleteIssueReportApi] = useApi()
  const [categorysResult, categoryApi] = useApi()
  const [addResult, addApi] = useApi()
  const routerHistory = useHistory()
  const formRef = useRef()
  const { t } = useTranslation()

  const IssueReportPriorityList = [
    { value: 1, name: t("global.low", "Low") },
    { value: 2, name: t("global.medium", "Medium") },
    { value: 3, name: t("global.high", "High") },
    { value: 4, name: t("vehicleregistry.driving_ban", "Driving Ban") }
  ]

  const IssueReportStatusList = [
    { value: 1, name: t("global.new", "New") },
    { value: 2, name: t("global.planned", "Planned") },
    { value: 3, name: t("global.booked", "Booked") },
    { value: 4, name: t("global.fixed", "fixed") },
    { value: 5, name: t("global.completed", "Completed") }
  ]

  // validation;
  const currentValidationSchema = Yup.object().shape({
    status: Yup.string().required(t("global.status_is_required", "Status is required")),
    statusNote: Yup.string().when("status", {
      is: "5",
      then: () => Yup.string().required(t("issuereports.status_note_is_required", "Status note is required")),
      otherwise: () => Yup.string().notRequired()
    }),
    priority: Yup.string().required(t("global.priority_is_required", "Priority is required")),
    description: Yup.string().max(
      300,
      t("global.description_can_only_300", "Description can be a maximum of 300 characters long.")
    ),
    issueReportCategoryId: Yup.string()
  })

  /* GET Categories */
  useEffect(() => {
    categoryApi.get(apiEndpoints.issuereports.getissuereportcategories)
    return () => {
      categoryApi.leave()
    }
  }, [categoryApi])

  useEffect(() => {
    setParentData(issuereportResult.data)
  }, [issuereportResult.data])

  /* GET Issue Report information */

  useEffect(() => {
    userstoassignFuncs.get(apiEndpoints.issuereportsadmin.getuserstoassign)

    return () => {
      userstoassignFuncs.leave()
    }
  }, [userstoassignFuncs])

  useEffect(() => {
    loadingContext.setLoading(() => addResult.status === 1)
    loadingContext.setLoading(() => fileUploadResult.status === 1)
    loadingContext.setLoading(() => categorysResult.status === 1)
  })

  useEffect(() => {
    if (addResult.status === 2) {
      issuereportFuncs.get(apiEndpoints.issuereports.getissuereport.replace("{id}", parentData?.id))
    }
  }, [addResult])

  useEffect(() => {
    if (updatedIssuereportResult.status === 2) {
      setParentData(updatedIssuereportResult.data)
      setShowContinueModal(false)
      setShowSuccessModal(true)
      setEditMode(false)

      if (formRef.current) {
        formRef.current.setFieldValue("note", "")
      }
    }
  }, [updatedIssuereportResult])

  // post data & set states for modals
  const onAddSubmit = (values) => {
    addApi.put(apiEndpoints.issuereportsadmin.updateissuereport, values)
    setShowSuccessModal(false)
  }

  const onDelete = () => {
    deleteIssueReportApi.del(
      apiEndpoints.issuereportsadmin.deleteissuereport.replace("{id}", issuereportResult.data.id)
    )
    setShowDeleteModal(false)
  }

  // handle submit formik form & show continue modal
  const handleSubmit = () => {
    setShowContinueModal(true)
  }

  useEffect(() => {
    // redirect back to list
    if (deleteResult.status === 2) routerHistory.push(allRoutes.IssuereportsDashboard())
  }, [deleteResult.status, routerHistory])

  const buttonFeedbackResult = addResult

  const buttonFeedbackResultDelete = deleteResult

  const [fileUploadResult, uploadFile] = useApiFile()
  const [files, setFiles] = useState([])
  const [filesPreview, setFilesPreview] = useState(initialValues.attachments)

  useEffect(() => {
    if (files) {
      files.map((file) => {
        return uploadFile(apiEndpoints.issuereports.uploadfile, file)
      })
    }
  }, [files, uploadFile])

  useEffect(() => {
    if (fileUploadResult.data && fileUploadResult.data.name) {
      setFilesPreview((p) => {
        return [...p, fileUploadResult.data]
      })
      issuereportResult.data.attachments.push(fileUploadResult.data)
    }
  }, [fileUploadResult])

  const onLogoChanged = (value) => {
    setFilesPreview(value)
  }

  const closeEdit = () => {
    setEditMode(false)
  }

  const handlePreSubmit = async () => {
    const errors = await formRef.current.validateForm()

    if (Object.keys(errors).length === 0) {
      setShowContinueModal(true)
    } else {
      formRef.current.setTouched(
        Object.fromEntries(Object.keys(formRef.current.values).map((key) => [key, true])),
        true
      )
    }
  }

  const statusNote = parentData?.notes?.find((note) => note.isStatusNote)
  return (
    <div>
      <Container sx={{ paddingTop: 0 }}>
        {parentData !== null && (
          <>
            <Formik
              initialValues={parentData}
              validationSchema={currentValidationSchema}
              onSubmit={handleSubmit}
              enableReinitialize={true}
              innerRef={formRef}>
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                isSubmitting,
                handleSubmit,
                setFieldValue
              }) => (
                <Box>
                  <form id="CustomFieldForm" onSubmit={handleSubmit} noValidate>
                    <RouterPrompt />
                    <Grid container spacing={4} mt={0}>
                      <Grid item xs={12} md={12}>
                        {hasRole(appContext.appUser, allRoles.IssueReportsAdmin) ? (
                          <StyledTwoButtonGrid mb={5}>
                            <WorkOrderTitle
                              title={t("issuereports.issuereports", "Issue reports")}
                              initialValues={parentData}
                            />
                            <Box sx={{ gap: "10px", display: "flex" }}>
                              {editMode ? (
                                <>
                                  <ClpButton onClick={closeEdit} color="primary" variant="outlined">
                                    {t("global.cancel", "Cancel")}
                                  </ClpButton>

                                  <ClpButton
                                    onClick={handlePreSubmit}
                                    color="secondary"
                                    startIcon={<SaveOutlinedIcon />}>
                                    {t("global.save", "Save")}
                                  </ClpButton>
                                </>
                              ) : (
                                <>
                                  <ClpButton
                                    onClick={() => setEditMode(true)}
                                    variant="outlined"
                                    startIcon={<EditIcon />}>
                                    {t("global.edit", "Edit")}
                                  </ClpButton>

                                  <ClpButton
                                    color="primary"
                                    component={Link}
                                    to={{
                                      pathname: allRoutes.IssuereportsWorkordersAdd(),
                                      state: issuereportResult.data.vehicleId
                                    }}
                                    startIcon={<AddCircleIcon />}
                                    variant="contained">
                                    {t("global.create_work_order", "Create work order")}
                                  </ClpButton>
                                </>
                              )}
                            </Box>
                          </StyledTwoButtonGrid>
                        ) : (
                          <></>
                        )}
                        <StyledWrapCard>
                          <Grid item xs={12} md={7}>
                            {editMode ? (
                              <>
                                <Typography pb={1} variant="h5">
                                  {t("global.category", "Category")}
                                </Typography>
                                {categorysResult.status === 2 && (
                                  <Autocomplete
                                    sx={{
                                      mb: 4,
                                      width: "500px",
                                      maxWidth: "100%"
                                    }}
                                    componentsProps={{ popper: { style: { width: "240px" } } }}
                                    id="issueReportCategoryId"
                                    options={categorysResult.data}
                                    getOptionLabel={(option) => (option.name ? option.name : "")}
                                    value={
                                      categorysResult.data.find(
                                        (i) => i.id === values.issueReportCategoryId
                                      ) || ""
                                    }
                                    isOptionEqualToValue={(option, value) => {
                                      return option.id === value.id
                                    }}
                                    onChange={(e, value) => {
                                      setFieldValue("issueReportCategoryId", value?.id)
                                      setChosenCategory(value?.id)
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        variant="outlined"
                                        name="issueReportCategoryId"
                                        error={
                                          touched.issueReportCategoryId && errors.issueReportCategoryId
                                            ? true
                                            : false
                                        }
                                        helperText={
                                          touched.issueReportCategoryId && errors.issueReportCategoryId
                                            ? errors.issueReportCategoryId
                                            : null
                                        }
                                      />
                                    )}
                                  />
                                )}{" "}
                              </>
                            ) : (
                              <Typography variant="h2" mb={4} color={theme.palette.primary["700"]}>
                                {issuereportResult.data?.issueReportCategory?.name
                                  ? issuereportResult.data.issueReportCategory.name
                                  : "-"}
                              </Typography>
                            )}
                            <StyledInlineBox>
                              <Grid mb={{ xs: 2, sm: 0 }} item xs={6} lg={2}>
                                <StyledInlineBoxLabel variant="bodySmall">
                                  {t("issuereports.reg_no", "Reg no")}:
                                </StyledInlineBoxLabel>
                                <Typography variant="h4">
                                  {parentData.vehicle?.regNumber ? parentData.vehicle.regNumber : "-"}
                                </Typography>
                              </Grid>
                              <Grid mb={{ xs: 2, sm: 0 }} item xs={6} lg={2}>
                                <StyledInlineBoxLabel variant="bodySmall">
                                  {t("issuereports.vehicle_id", "VehicleID")}:
                                </StyledInlineBoxLabel>
                                <Typography variant="h4">
                                  {parentData.vehicle?.internnumber ? parentData.vehicle.internnumber : "-"}
                                </Typography>
                              </Grid>
                              <Grid mb={{ xs: 2, sm: 0 }} item xs={6} lg={2}>
                                <StyledInlineBoxLabel variant="bodySmall">
                                  {t("global.created_by", "Created by")}:
                                </StyledInlineBoxLabel>
                                <Typography variant="h4">
                                  {parentData.createdByUser?.name ? parentData.createdByUser.name : "-"}
                                </Typography>
                              </Grid>
                              <Grid mb={{ xs: 2, sm: 0 }} item xs={6} lg={2}>
                                <StyledInlineBoxLabel variant="bodySmall">
                                  {t("global.created_when", "Created when")}:
                                </StyledInlineBoxLabel>
                                <Typography variant="h4">
                                  {parentData.createdDate ? (
                                    <Moment format="YYYY-MM-DD">{parentData.createdDate}</Moment>
                                  ) : (
                                    "-"
                                  )}
                                </Typography>
                              </Grid>
                            </StyledInlineBox>

                            <Grid>
                              <Typography pt={4} pb={1} variant="h5">
                                {t("global.description", "Description")}
                              </Typography>
                              {editMode ? (
                                <>
                                  <StyledListItem>
                                    <TextField
                                      minRows={4}
                                      multiline
                                      autoComplete="off"
                                      fullWidth
                                      id="description"
                                      value={values.description}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      error={touched.description && errors.description ? true : false}
                                      helperText={
                                        touched.description && errors.description ? errors.description : null
                                      }
                                      variant="outlined"
                                      InputProps={{
                                        disableUnderline: true
                                      }}
                                    />
                                  </StyledListItem>
                                </>
                              ) : (
                                <Typography>{parentData.description}</Typography>
                              )}
                            </Grid>

                            <Grid>
                              <Typography pt={4} pb={1} variant="h5">
                                {t("global.meter_setting", "Meter setting")}
                              </Typography>
                              {editMode ? (
                                <>
                                  <StyledListItem>
                                    <TextField
                                      minRows={1}
                                      multiline
                                      autoComplete="off"
                                      fullWidth
                                      id="meterSetting"
                                      value={values.meterSetting}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      error={touched.meterSetting && errors.meterSetting ? true : false}
                                      helperText={
                                        touched.meterSetting && errors.meterSetting
                                          ? errors.meterSetting
                                          : null
                                      }
                                      variant="outlined"
                                      InputProps={{
                                        disableUnderline: true
                                      }}
                                    />
                                  </StyledListItem>
                                </>
                              ) : (
                                <Typography>{parentData.meterSetting}</Typography>
                              )}
                            </Grid>
                            <Grid>
                              <Typography pt={4} pb={1} variant="h5">
                                {t("issuereports.status_note", "Work note")}
                              </Typography>
                              <Box display="flex" flexDirection="column" gap={2}>
                                {(() => {
                                  if (!statusNote) return null

                                  return (
                                    <Box display="flex" flexDirection="column" gap={1}>
                                      <Typography variant="bodySmall" color="textSecondary">
                                        {statusNote.createdByUserName}{" "}
                                        {moment
                                          .utc(statusNote.createdDate)
                                          .local()
                                          .format("YYYY-MM-DD HH:mm")}
                                      </Typography>
                                      <Typography>{statusNote.text}</Typography>
                                    </Box>
                                  )
                                })()}
                              </Box>

                              <Typography pt={4} pb={1} variant="h5">
                                {t("global.notes", "Notes")}
                              </Typography>
                              <Box display="flex" flexDirection="column" gap={2}>
                                {parentData?.notes
                                  ?.filter((note) => note.isStatusNote === false)
                                  .map((data, index) => (
                                    <Box key={index} display="flex" flexDirection="column" gap={1}>
                                      <Typography variant="bodySmall" color="textSecondary">
                                        {data.createdByUserName}{" "}
                                        {data.createdDate &&
                                        moment(data.createdDate).isAfter("0001-01-01T00:00:00")
                                          ? moment.utc(data.createdDate).local().format("YYYY-MM-DD HH:mm")
                                          : "-"}
                                      </Typography>
                                      <Typography>{data.text}</Typography>
                                    </Box>
                                  ))}
                              </Box>
                            </Grid>

                            <Grid>
                              <Typography pt={4} variant="h5">
                                {t("global.media", "Media")}
                              </Typography>
                              <MultipleFilePickerPreviewList
                                parentData={parentData}
                                setFilesPreview={filesPreview}
                                setFieldValue={setFieldValue}
                                fieldName="attachments"
                                defaultPreviewFiles={parentData.attachments}
                                setFiles={setFiles}
                                files={files}
                                fileUploadResult={fileUploadResult}
                                onLogoChanged={onLogoChanged}
                                labelInBox={t("global.attach_images", "Attach files from your device")}
                                editMode={editMode}
                              />
                            </Grid>
                          </Grid>

                          <Grid item md={4} xs={12} direction="row" pt={{ xs: 4, md: 0 }}>
                            <Typography variant="h5">{t("global.table.status", "Status")}</Typography>
                            {hasRole(appContext.appUser, allRoles.IssueReportsAdmin) ? (
                              <StyledWhiteBox sx={{ minWidth: 200 }} mt={1} mb={2.5}>
                                <FormControl fullWidth>
                                  <InputLabel id="status"></InputLabel>
                                  <Select
                                    labelId="status"
                                    id="status"
                                    onChange={(event) => setFieldValue("status", event.target.value)}
                                    defaultValue={values.status ? values.status : ""}
                                    error={touched.status && errors.status ? true : false}>
                                    {IssueReportStatusList.map((data, index) => (
                                      <MenuItem value={data.value} key={index}>
                                        {data.name}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                                {values.status === 5 && (
                                  <Box mt={2}>
                                    <Typography variant="h5" mb={1}>
                                      {t("issuereports.status_note", "Status note")}
                                    </Typography>
                                    <FormControl fullWidth>
                                      <TextField
                                        name="statusNote"
                                        rows={3}
                                        multiline
                                        autoComplete="off"
                                        fullWidth
                                        id="statusNote"
                                        placeholder={t(
                                          "issuereports.what_has_been_fixed",
                                          "What has been fixed on the vehicle?"
                                        )}
                                        value={values.statusNote}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={touched.statusNote && errors.statusNote ? true : false}
                                        helperText={
                                          touched.statusNote && errors.statusNote ? errors.statusNote : null
                                        }
                                        variant="outlined"
                                        InputProps={{
                                          disableUnderline: true
                                        }}
                                      />
                                    </FormControl>
                                  </Box>
                                )}
                              </StyledWhiteBox>
                            ) : (
                              <Box color={`${issueReportStatusColor(values.status)}.main`}>
                                <FontAwesomeIcon icon={issueReportStatusIcon(values.status)} />
                                <Typography sx={{ marginLeft: "5px", display: "inline" }} variant="h5">
                                  {issueReportStatusLabel(values.status, t)}
                                </Typography>
                              </Box>
                            )}
                            {hasRole(appContext.appUser, allRoles.IssueReportsAdmin) && (
                              <>
                                <Typography variant="h5">{t("global.table.priority", "Priority")}</Typography>
                                <StyledWhiteBox sx={{ minWidth: 200 }} mt={1} mb={2.5}>
                                  <FormControl fullWidth>
                                    <InputLabel id="priority"></InputLabel>
                                    <Select
                                      labelId="priority"
                                      id="priority"
                                      onChange={(event) => setFieldValue("priority", event.target.value)}
                                      defaultValue={values.priority ? values.priority : ""}
                                      error={touched.priority && errors.priority ? true : false}>
                                      {IssueReportPriorityList.map((data, index) => (
                                        <MenuItem value={data.value} key={index}>
                                          {data.name}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </StyledWhiteBox>

                                <Typography variant="h5">{t("deviation.assign", "Assign")}</Typography>

                                <StyledWhiteBox sx={{ minWidth: 200 }} mt={1} mb={2.5}>
                                  {userstoassign.status === 2 && (
                                    <FormControl fullWidth>
                                      <InputLabel id="responsibleUserId"></InputLabel>
                                      <Select
                                        labelId="responsibleUserId"
                                        id="responsibleUserId"
                                        onChange={(event) => {
                                          setFieldValue("responsibleUserId", event.target.value)
                                        }}
                                        defaultValue={
                                          values.responsibleUserId ? values.responsibleUserId : ""
                                        }>
                                        {userstoassign.data.map((data, index) => (
                                          <MenuItem value={data.id} key={index}>
                                            {data.name}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </FormControl>
                                  )}
                                </StyledWhiteBox>

                                <Typography variant="h5">{t("planning.note", "Note")}</Typography>

                                <StyledWhiteBox sx={{ minWidth: 200 }} mt={1} mb={2.5}>
                                  <FormControl fullWidth>
                                    <TextField
                                      rows={3}
                                      multiline
                                      autoComplete="off"
                                      fullWidth
                                      id="note"
                                      value={values.note}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      error={touched.note && errors.note ? true : false}
                                      helperText={touched.note && errors.note ? errors.note : null}
                                      variant="outlined"
                                      InputProps={{
                                        disableUnderline: true
                                      }}
                                    />
                                  </FormControl>
                                </StyledWhiteBox>
                                <Grid container direction={"row-reverse"}>
                                  <ClpButton onClick={handlePreSubmit} color="primary" variant="contained">
                                    {t("global.save", "Save")}
                                  </ClpButton>
                                </Grid>
                              </>
                            )}
                          </Grid>
                        </StyledWrapCard>
                      </Grid>
                    </Grid>
                    {/* {!appContext.appUser.customer.issueReportDeleteDisabled && [
                      <Box mt={3}>
                        <ClpButton
                          result={buttonFeedbackResultDelete}
                          onClick={() => {
                            setShowDeleteModal(true)
                          }}
                          startIcon={<DeleteIcon />}
                          color="error"
                          variant="outlined">
                          {t("issuereports.remove_issuereport", "Delete issue report")}
                        </ClpButton>
                      </Box>
                    ]} */}

                    {showContinueModal && (
                      <ContinueDialog
                        setShowContinueModal={setShowContinueModal}
                        onAddSubmit={onAddSubmit}
                        values={values}
                        message={t("global.do_you_want_to_save_changes", "Do you want to save changes")}
                        continueBtnText={t("global.save", "Save")}
                        cancelBtnText={t("global.cancel", "Cancel")}
                      />
                    )}
                    {showDeleteModel && (
                      <ContinueDialog
                        result={deleteResult}
                        setShowContinueModal={setShowDeleteModal}
                        onAddSubmit={onDelete}
                        message={t(
                          "issuereports.do_you_want_to_delete_issuereport",
                          "Do you want to delete the issue report?"
                        )}
                        continueBtnText={t("issuereports.remove_issuereport", "Delete issue report")}
                        cancelBtnText={t("global.cancel", "Cancel")}
                      />
                    )}
                    {showSuccessModal && <SuccessDialog title="Din felrapport har sparats." />}
                  </form>
                </Box>
              )}
            </Formik>
          </>
        )}
      </Container>
    </div>
  )
}

export default IssueReports
